import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { ICustomFieldValues } from '../../interfaces/custom-field.interface';

import { ESalesOrderLineItemStatus } from './../../../sales-order/interfaces/sales-order.interface';

@Injectable({
  providedIn: 'root',
})
export class RfqUtilService {
  constructor(private fb :UntypedFormBuilder) {}

  getItemFormGroup(item :any) :UntypedFormGroup {
    const {
      id, // THIS ID IS RFQ ID
      lineItemId, // THIS ID IS mt shipstation order item id
      description,
      sku,
      internal_sku,
      product_name,
      is_kit,
      unit_price,
      quantity,
      default_selling_unit_id,
      type,
      is_overridden,
      unit_class_id,
      category,
      subcategory,
      uom_id,
      estimated_ship_date,
      line_item_status,
      original_quantity_ordered,
      discount_amount,
      discount_percent,
      customFieldValues,
    } = item;

    const unit_of_measures = this.fb.array(
      (item.unit_of_measures || []).map((uom :any) =>
        this.fb.group({
          id: uom.id,
          name: uom.name,
        }),
      ),
    );

    const customFieldValuesGroup = this.fb.group(
      (customFieldValues || []).reduce((acc, field) => {
        acc[field.id.toString()] = this.fb.group({
          id: [field.id],
          value: [field.value],
        });

        return acc;
      }, {}),
    );

    const uomIdValue = uom_id !== undefined ? uom_id : default_selling_unit_id;
    const itemQuantity = Number(quantity || 1);

    return this.fb.group({
      id: lineItemId || 0,
      description,
      item_id: id,
      sku,
      internal_sku,
      product: item,
      product_name,
      is_kit,
      quantity: itemQuantity,
      original_unit_price: unit_price,
      unit_price,
      net_total_amount: itemQuantity * unit_price - (discount_amount || 0),
      discount_amount: discount_amount || 0,
      discount_percent: discount_percent || 0,
      discount_amount_per_unit: 0,
      markup_amount: 0,
      markup_amount_per_unit: 0,
      ordered_uom_id: uomIdValue || 0,
      order: 0,
      unit_of_measures, // Not included in the payload
      stock: this.fb.control(item.stock), // Not included in the payload
      location_stock: this.fb.control(item.location_stock), // Not included in the payload
      oss_limit_notify: item.oss_limit_notify, // Not included in the payload
      type, // Not included in the payload
      is_overridden, // Not included in the payload
      selected: false, // Not included in the payload
      default_selling_unit_id, // Not included in the payload
      unit_class_id, // Not included in the payload
      category,
      subcategory,
      uom_id,
      estimated_ship_date,
      line_item_status: line_item_status || ESalesOrderLineItemStatus.ACCEPTED,
      original_quantity_ordered,
      customFieldValues: customFieldValuesGroup,
    });
  }

  emptyItemRow() :UntypedFormGroup {
    return this.fb.group({
      id: 0,
      description: '',
      // Genereate a unique umber to avoid conflicts with the items,
      item_id: Math.floor(Math.random() * 1000000000),
      product_id: 0,
      sku: '',
      product_name: '',
      product: null,
      is_kit: 0,
      quantity: 0,
      original_unit_price: 0,
      unit_price: 0,
      net_total_amount: 0,
      discount_amount: 0,
      discount_percent: 0,
      discount_amount_per_unit: 0,
      markup_amount: 0,
      markup_amount_per_unit: 0,
      ordered_uom_id: 0,
      order: 0,
      unit_of_measures: this.fb.array([]),
      stock: this.fb.control(0),
      location_stock: this.fb.control(0),
      oss_limit_notify: 0,
      type: '',
      selected: false,
      row_type: null,
      estimated_ship_date: null,
      original_quantity_ordered: 0,
      customFieldValues: this.fb.array([]),
    });
  }

  formatItemGroup(item :any) :any {
    const customFieldValues = (item?.customFieldValues || []).map(
      (field :ICustomFieldValues) => ({
        id: field.customFieldId,
        value: field?.valueString || field?.valueNumber || field?.valueDate,
      }),
    );

    return {
      id: item?.rfq?.id,
      lineItemId: item?.id, //add this to check what are the changes on line item. getItemFormGroup to return a proper id also not zero
      description: item?.rfq?.productDescription,
      sku: item?.sku,
      internal_sku: item?.rfq?.internalSku,
      product_name: item?.rfq?.productName,
      is_kit: item?.kitId === 0 ? false : true,
      unit_price: item?.unitPrice,
      quantity: item?.quantity,
      default_selling_unit_id: item?.defaultSellingUnitId,
      type: item?.rfq?.type,
      is_overridden: false,
      unit_class_id: item?.rfq?.unitClassId,
      uom_id: item?.orderedUomId,
      unit_of_measures: item?.rfq?.unitOfMeasures,
      location_stock: item?.rfq?.locationStock,
      estimated_ship_date: item?.estimatedShipDate,
      line_item_status: item?.lineItemStatus,
      original_quantity_ordered: item?.originalQuantityOrdered,
      discount_amount: item?.discount || 0,
      discount_percent: item?.discount
        ? (item?.discount / (item?.unitPrice * item?.quantity)) * 100
        : 0,
      customFieldValues,
    };
  }
}
